import { IPartialTransformation, ITransformation } from './types';

export function isTransformationFullyDefined(
  transformation: IPartialTransformation | null,
): transformation is ITransformation {
  if (transformation == null) return false;

  switch (transformation.type) {
    case 'movement':
      return transformation.origin != null && transformation.destination != null;

    case 'rotation':
    case 'mirror':
      return transformation.center != null;
  }
}
